import React, {Component} from 'react';
import $ from 'jquery';

class Alert extends Component {
  componentDidMount() {
    $(function() {
      $(document).on('click', '.close', function() {
          $(this).parent().hide();
      })
   });
  }
  render(props) {
    let alerts;
    console.log(this.props.alert);
    const danger = (
      <div id="alert" className="alert alert-danger fade show" role="alert">
  <button type="button" className="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <strong>Oh no!</strong> Email was not sent, please try again. If error persists please give us a call.</div>
    )

    const success = (
      <div id="alert" className="alert alert-success fade show" role="alert">
  <button type="button" className="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <strong>Hooray!</strong> Email was successfully sent, we will be in touch soon!</div>
    )
    if(this.props.alert === 'success') {
      alerts = success
    } else {
      alerts = danger
    }
    return (
      alerts
    )
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.js